<div class="list-page">
  <div app-kirjanpito-projektien-tyylit [kirjanpidonProjektitObservable]="kirjanpidonProjektitObservable"></div>
  <app-asiakas-otsikko otsikko="Selaa tositteita" [paluuUrl]="'/asiakkaat'" [asiakas]="asiakasObservable | async"></app-asiakas-otsikko>

  @if (kirjanpitajaOnDevaajaObservable | async) {
    <div style="padding-bottom: 20px">
      <h3 style="margin: 0">Urit</h3>
      <div style="padding-top: 1em; padding-left: 1em; padding-right: 1em">
        Kuitit (Lemonaid): <a [href]="kuititEncodedUriObservable | async" target="_BLANK">{{ kuititUriObservable | async }}</a>
      </div>
    </div>
  }

  <div class="hakukontrollit">
    <mat-form-field style="width: 183px; margin-right: 2em">
      <mat-icon matPrefix class="listaus-haku-ikoni">search</mat-icon>
      <mat-label>{{ 'kuitit.etsi' | translate | async }}</mat-label>
      <input type="text" matInput readonly (click)="avaaHaku()" style="cursor: pointer" [attr.aria-label]="'tositteet.avaa-haku' | translate | async" />
    </mat-form-field>

    <mat-form-field style="width: 183px; margin: 0">
      <mat-label>Näytä</mat-label>
      <mat-select #naytaKaikki>
        <mat-option [value]="false"> Poistamattomat tositteet </mat-option>
        <mat-option [value]="true"> Kaikki tositteet </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="kuukausi-valinta">
    <table style="margin-left: auto; margin-right: auto">
      <tr>
        <td>
          <app-icon-button (click)="edellinenKuukausi($event)" actionId="Tositteet: edellinen kuukausi" additionalClass="dark-gray-text large-icon-button" styles="position: relative; padding-right: 10px;">
            <i class="icon ion-ios-arrow-back mat-icon"></i>
            @if (edellisenKuukaudenSelvitettavat() > 0) {
              <span class="selvitettavat-merkki selvitettavat-merkki-vasen">{{ edellisenKuukaudenSelvitettavat() }}</span>
            }
          </app-icon-button>
        </td>
        <td (click)="dp.open()" style="width: 240px; font-size: 28px; line-height: 34px; text-align: center; cursor: pointer" class="light-blue-text">
          {{ otsikkoObservable | async }}
          <mat-datepicker #dp startView="year" (monthSelected)="chosenMonthHandler($event, dp)" panelClass="kuukausi-valitsin"></mat-datepicker>
          <input matInput [matDatepicker]="dp" style="width: 1px; visibility: hidden" />
        </td>
        <td>
          <app-icon-button (click)="seuraavaKuukausi($event)" actionId="Tositteet: seuraava kuukausi" additionalClass="dark-gray-text large-icon-button" styles="position: relative; padding-left: 10px;">
            <i class="icon ion-ios-arrow-forward mat-icon"></i>
            @if (seuraavanKuukaudenSelvitettavat() > 0) {
              <span class="selvitettavat-merkki selvitettavat-merkki-oikea">{{ seuraavanKuukaudenSelvitettavat() }}</span>
            }
          </app-icon-button>
        </td>
      </tr>
    </table>
  </div>

  <div class="maksutapa-valinta" role="group" [attr.aria-label]="'kuitit.rajaa-maksutavalla' | translate | async">
    <app-button (click)="valitseMaksutapa(null)" actionId="Tositteet: rajaa maksutavalla" [actionContext]="['kaikki']" additionalClass="maksutapa-pilleri" [dynamicClass]="{ 'maksutapa-pilleri-valittu': valittuMaksutapa() === null }">
      <span class="maksutapa-ikoni"><mat-icon class="maksutapa-ikoni-symboli">grid_view</mat-icon></span>
      <span class="maksutapa-nimi">{{ 'kuitit.maksutapa-kaikki' | translate | async }}</span>
      <span class="maksutapa-maara">{{ kaikkienLukumaara() }}</span>
    </app-button>
    @for (valinta of maksutapaValinnat(); track valinta.tunniste) {
      <app-button (click)="valitseMaksutapa(valinta.tunniste)" actionId="Tositteet: rajaa maksutavalla" [actionContext]="[valinta.tunniste]" additionalClass="maksutapa-pilleri" [dynamicClass]="{ 'maksutapa-pilleri-valittu': valittuMaksutapa() === valinta.tunniste }">
        <span class="maksutapa-ikoni">
          @if (valinta.kuva) {
            <img class="maksutapa-ikoni-kuva" [src]="valinta.kuva" alt="" />
          }
        </span>
        <span class="maksutapa-nimi">{{ valinta.nimi }}</span>
        <span class="maksutapa-maara">{{ valinta.lukumaara }}</span>
      </app-button>
    }
  </div>

  <div class="yhteenveto">
    <div class="yhteenveto-summa">{{ kuukaudenYhteissumma() }}</div>
    <div class="yhteenveto-maara dark-gray-text">
      {{ 'kuitit.yhteensa' | translate | async }} {{ tositteidenKokonaismaara }}
      {{ tositteidenKokonaismaara === 1 ? ('kuitit.tosite' | translate | async) : ('kuitit.tositetta' | translate | async) }}
    </div>
  </div>

  @if (selvitysniput().length > 0) {
    <div class="osion-otsikko">
      <span class="osion-otsikko-teksti">{{ 'kuitit.selvitettavat' | translate | async }}</span>
      <span class="osion-otsikko-maara">{{ selvityspyynnot().length }}</span>
    </div>

    <div class="selvitysniput">
      @for (nippu of selvitysniput(); track nippu.tyyppi) {
        <div class="selvitysnippu">
          <div class="selvitysnippu-kortit">
            @for (kortti of nippu.naytettavat; track kortti.avain) {
              <div class="huomio-kortti">
                <app-tosite-selvitys-kortti [kortti]="kortti" [asiakas]="asiakas"></app-tosite-selvitys-kortti>
                @if (!nippu.auki && nippu.kortit.length > 1) {
                  <span class="huomio-merkki">{{ nippu.kortit.length }}</span>
                }
              </div>
            }
          </div>
          @if (nippu.auki) {
            <app-button (click)="niputaSelvitettavat(nippu.tyyppi)" actionId="Selvityspyynnöt: niputa" [actionContext]="[nippu.tyyppi]" additionalClass="niputa-button" matIcon="keyboard_arrow_up">
              {{ 'kuitit.nippu-niputa' | translate | async }}
            </app-button>
          } @else if (nippu.kortit.length > 1) {
            <app-button (click)="avaaSelvitysnippu(nippu.tyyppi)" actionId="Selvityspyynnöt: näytä kaikki" [actionContext]="[nippu.tyyppi]" additionalClass="nayta-kaikki-button">
              {{ 'kuitit.nippu-nayta-kaikki' | translate: { maara: nippu.kortit.length } | async }}
            </app-button>
          }
        </div>
      }
    </div>
  }

  <div class="naytto-valinta">
    <app-icon-button (click)="vaihdaNaytto('kortit')" actionId="Tositteet: näytä kortteina" matIcon="grid_view" title="Näytä kortteina" [dynamicClass]="{ 'naytto-valittu': naytto === 'kortit' }"></app-icon-button>
    <app-icon-button (click)="vaihdaNaytto('lista')" actionId="Tositteet: näytä tiiviinä listana" matIcon="view_list" title="Tiivis" [dynamicClass]="{ 'naytto-valittu': naytto === 'lista' }"></app-icon-button>
    <app-icon-button (click)="vaihdaNaytto('kuvilla')" actionId="Tositteet: näytä kuvilla" matIcon="view_agenda" title="Kuvilla" [dynamicClass]="{ 'naytto-valittu': naytto === 'kuvilla' }"></app-icon-button>
  </div>

  @if (naytto === 'lista') {
    <div style="position: relative">
      <mat-table matSort [dataSource]="dataSource" [matSortDisableClear]="true" style="min-height: 94px">
        <ng-container matColumnDef="pvm">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="sarake-pvm">{{ 'tositteet.paivamaara' | translate | async }}</mat-header-cell>
          <mat-cell *matCellDef="let row" class="sarake-pvm">{{ row.p | lnumberpvm | async }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="toimittaja">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'tositteet.toimittaja' | translate | async }}</mat-header-cell>
          <mat-cell *matCellDef="let row" [class.toimittaja-puuttuu]="!row.seller && !row.el">{{ row.seller || row.el || ('tositteet.ei-toimittajaa' | translate | async) }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="projekti">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="sarake-projekti">{{ 'tositteet.projekti' | translate | async }}</mat-header-cell>
          <mat-cell *matCellDef="let row" class="sarake-projekti">
            @if (projektitMap().get(row.projektiAvain); as projekti) {
              <span [class]="'a' + projekti.avain + ' kr-projekti-dot projekti-pallo'"></span>
              <span class="projekti-nimi">{{ projekti.nimi }}</span>
            }
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="lisatiedot">
          <mat-header-cell *matHeaderCellDef class="sarake-lisatiedot">{{ 'tositteet.lisatiedot' | translate | async }}</mat-header-cell>
          <mat-cell *matCellDef="let row" class="sarake-lisatiedot">{{ row.selite }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="maksutapa">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="sarake-maksutapa">{{ 'tositteet.maksutapa' | translate | async }}</mat-header-cell>
          <mat-cell *matCellDef="let row" class="sarake-maksutapa">{{ maksutapaNimi(row) }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="summa">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="sarake-summa">{{ 'tositteet.summa' | translate | async }}</mat-header-cell>
          <mat-cell *matCellDef="let row" class="sarake-summa">{{ row.sum ?? row.summa | lmoney: 'EUR' | async }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="tila">
          <mat-header-cell *matHeaderCellDef class="sarake-tila"></mat-header-cell>
          <mat-cell *matCellDef="let row" class="sarake-tila">
            @if (!row.vihreaPilvi) {
              <mat-icon class="yellow-text flashit" matTooltip="Tositteen käsittely on kesken">cloud_upload</mat-icon>
            } @else if (testisettiMerkit().get(row.avain); as merkki) {
              <mat-icon class="testisetti-ikoni" [matTooltip]="merkki.vihje">science</mat-icon>
            }
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="testisetti">
          <mat-header-cell *matHeaderCellDef class="sarake-testisetti"></mat-header-cell>
          <mat-cell *matCellDef="let row" class="sarake-testisetti">
            <mat-checkbox [checked]="valitutTestisettiin().has(row.avain)" (click)="$event.stopPropagation()" (change)="toggleTestisettiValinta(row.avain, $event.checked)" matTooltip="Valitse LLM-testisettiin"></mat-checkbox>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns()"></mat-header-row>
        <mat-row (click)="katsele(row)" [class.poistettu-tosite]="row.poistettu" *matRowDef="let row; columns: displayedColumns()"></mat-row>
      </mat-table>

      @if ((rivienMaaraObservable | async) === 0 && (lataaObservable | async) === false) {
        <div class="table-ladataan" style="position: absolute; top: 0px; width: 100%; height: 100%; display: flex; justify-items: center; align-items: center">
          <div class="dark-gray-text" style="width: 100%; padding-top: 40px; text-align: center">Hakuehdoilla ei löytynyt yhtään tositetta.</div>
        </div>
      }
      @if (lataaObservable | async) {
        <div style="position: absolute; top: 0px; width: 100%; height: 100%; display: flex; justify-items: center; align-items: center">
          <div style="width: 100%; padding-top: 40px; text-align: center">
            <div lemon-loading [show]="true"></div>
          </div>
        </div>
      }
    </div>

    <mat-paginator [length]="rivienMaaraObservable | async" [pageIndex]="dataSource.page.pageIndex" [pageSize]="dataSource.page.pageSize" [pageSizeOptions]="[20, 50, 200]"></mat-paginator>
  } @else {
    <div>
      @if (!(lataaObservable | async) && naytto === 'kuvilla') {
        <div class="kuvilla-lista lemon-mat-elevation-z4">
          @for (kuitti of naytettavatKuititObservable | async; track kuitti) {
            <div class="kuvilla-rivi" [class.poistettu-kuitti]="kuitti.poistettu" tabindex="0" role="button" (click)="katsele(kuitti)" (keydown)="kuvillaRiviNappain($event, kuitti)">
              <div class="kuvilla-kuva">
                @if (kuitti.kuvienMaara === 0 || kuitti.kuvaEpaonnistui) {
                  <div class="kuvilla-ei-kuvaa">Ei kuvaa</div>
                } @else {
                  @if (kuitti.ladataan) {
                    <div class="kuvilla-paikanpitaja" aria-hidden="true">
                      <span class="kuvilla-paikanpitaja-rivi kuvilla-paikanpitaja-otsikko"></span>
                      <span class="kuvilla-paikanpitaja-rivi"></span>
                      <span class="kuvilla-paikanpitaja-rivi kuvilla-paikanpitaja-lyhyt"></span>
                      <span class="kuvilla-paikanpitaja-rivi"></span>
                      <span class="kuvilla-paikanpitaja-rivi kuvilla-paikanpitaja-lyhyt"></span>
                      <span class="kuvilla-paikanpitaja-rivi kuvilla-paikanpitaja-summa"></span>
                    </div>
                  }
                  <img [src]="kuitti.ensimmainenKuva" [class.kuvilla-kuva-ladattu]="!kuitti.ladataan" (load)="kuvanLataaminenValmis(kuitti)" (error)="kuvanLataaminenEpaonnistui(kuitti)" crossorigin="use-credentials" loading="lazy" alt="" />
                }
                @if (kuitti.kuvienMaara > 1) {
                  <span class="kuvilla-sivumaara">{{ kuitti.kuvienMaara }}</span>
                }
              </div>
              <div class="kuvilla-tiedot">
                <div class="kuvilla-otsikkorivi">
                  <div class="kuvilla-toimittaja" [class.toimittaja-puuttuu]="!kuitti.seller && !kuitti.el">{{ kuitti.seller || kuitti.el || ('tositteet.ei-toimittajaa' | translate | async) }}</div>
                  <div class="kuvilla-summa">{{ kuitti.sum ?? kuitti.summa | lmoney: 'EUR' | async }}</div>
                </div>
                <div class="kuvilla-pvm dark-gray-text">
                  {{ kuitti.localPvm | lokaalipvm | async }}
                  @if (!kuitti.vihreaPilvi) {
                    <mat-icon class="kuvilla-tila-ikoni yellow-text flashit" matTooltip="Tositteen käsittely on kesken">cloud_upload</mat-icon>
                  }
                  @if (testisettiMerkit().get(kuitti.avain); as merkki) {
                    <mat-icon class="kuvilla-tila-ikoni testisetti-ikoni" [matTooltip]="merkki.vihje">science</mat-icon>
                  }
                </div>
                @if (kuitti.selite) {
                  <div class="kuvilla-selite dark-gray-text">{{ kuitti.selite }}</div>
                }
                <div class="kuvilla-alarivi dark-gray-text">
                  <span class="kuvilla-maksutapa">{{ maksutapaNimi(kuitti) }}</span>
                  @if (projektitMap().get(kuitti.projektiAvain); as projekti) {
                    <span [class]="'a' + projekti.avain + ' kr-projekti-dot projekti-pallo'"></span>
                    <span class="projekti-nimi">{{ projekti.nimi }}</span>
                  }
                </div>
              </div>
              @if (onkoLlmTestausKayttajaObservable | async) {
                <mat-checkbox class="kuvilla-testisetti" [checked]="valitutTestisettiin().has(kuitti.avain)" (click)="$event.stopPropagation()" (change)="toggleTestisettiValinta(kuitti.avain, $event.checked)" matTooltip="Valitse LLM-testisettiin"></mat-checkbox>
              }
            </div>
          }
        </div>
      } @else if (!(lataaObservable | async)) {
        <div class="kortti-container">
          @for (kuitti of naytettavatKuititObservable | async; track kuitti) {
            <div [class.poistettu-kuitti]="kuitti.poistettu" class="kuitti-laatikko lemon-mat-elevation-z4" (click)="katsele(kuitti)">
              <div class="kuitti-laatikko-inner">
                @if (onkoLlmTestausKayttajaObservable | async) {
                  <mat-checkbox class="testisetti-valinta" [checked]="valitutTestisettiin().has(kuitti.avain)" (click)="$event.stopPropagation()" (change)="toggleTestisettiValinta(kuitti.avain, $event.checked)" matTooltip="Valitse LLM-testisettiin"></mat-checkbox>
                }
                @if (kuitti.vihreaPilvi) {
                  <mat-icon style="position: absolute; right: 5px; top: 5px" class="green-text">cloud_done</mat-icon>
                } @else {
                  <mat-icon style="position: absolute; right: 8px; top: 5px" class="yellow-text flashit">cloud_upload</mat-icon>
                }
                <div class="kuva-container">
                  @if (kuitti.ensimmainenKuva) {
                    <img [src]="kuitti.ensimmainenKuva" (load)="kuvanLataaminenValmis(kuitti)" crossorigin="use-credentials" loading="lazy" />
                  }
                  <div lemon-loading [show]="kuitti.ladataan"></div>
                </div>
                <div class="tiedot-container">
                  <div class="pvm dark-gray-text">{{ kuitti.localPvm | lokaalipvm | async }}</div>
                  <div class="summa light-blue-text">{{ kuitti.sum ?? kuitti.summa | lmoney: 'EUR' | async }}</div>
                  <div class="viiva light-gray-background"></div>
                  @if (testisettiMerkit().get(kuitti.avain); as merkki) {
                    <div class="testisetti-merkki" [matTooltip]="merkki.vihje"><mat-icon>science</mat-icon>{{ merkki.teksti }}</div>
                  }
                  @if (!kuitti?.w && (kuitti?.el || kuitti?.seller)) {
                    <div class="el-kommentti">{{ kuitti.el || kuitti.seller }}</div>
                  }
                  <div class="selite-container">
                    @if (kuitti.w) {
                      <div class="dark-gray-text">{{ kuitti.w }}</div>
                    }
                    @if (!kuitti.w && kuitti.c) {
                      <div class="dark-gray-text">{{ kuitti.c }}</div>
                    }
                    <div class="bottom-container">
                      <div class="selite dark-gray-text">{{ kuitti.selite }}</div>
                      @if (kuitti.naytaLisaa) {
                        <div [@slide] (click)="toggleNaytaLisaa($event, kuitti)">
                          <div class="tosite-api-msg">{{ kuitti.userApiMessage }}</div>
                        </div>
                      }
                      @if (kuitti.userApiMessage) {
                        <div (click)="toggleNaytaLisaa($event, kuitti)" class="nayta-lisaa dark-gray-text">
                          {{ (kuitti.naytaLisaa ? 'kuitit.nayta-vahemman' : 'kuitit.nayta-lisaa') | translate | async }} <span class="arrow">{{ kuitti.naytaLisaa ? '▲' : '▼' }}</span>
                        </div>
                      }
                      @if (kuitti.m) {
                        <div class="selv-kommentti">{{ kuitti.m }}</div>
                      }
                      @if (projektitMap().get(kuitti.projektiAvain); as projekti) {
                        <div class="projekti dark-gray-text">
                          <span [class]="'a' + projekti.avain + ' kr-projekti-dot projekti-pallo'"></span>
                          <span>{{ projekti.nimi }}</span>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
              <div class="lisatiedot dark-gray-text">Luotu: {{ kuitti.tallennettuKannykassa?.toDate() | ldatetime | async }}</div>
            </div>
          }
        </div>
      }

      @if (naytaEiYhtaanObservable | async) {
        <div class="table-ladataan" style="position: relative; top: 0px; width: 100%; height: 100%; display: flex; justify-items: center; align-items: center">
          <div class="dark-gray-text" style="width: 100%; padding-top: 50px; text-align: center; margin: 10px 40px">Hakuehdoilla ei löytynyt yhtään tositetta.</div>
        </div>
      }
      @if (lataaObservable | async) {
        <div style="position: relative; top: 0px; width: 100%; height: 100%; display: flex; justify-items: center; align-items: center">
          <div class="dark-gray-text" style="width: 100%; padding-top: 50px; text-align: center; margin: 10px 40px">
            <div lemon-loading [show]="true"></div>
          </div>
        </div>
      }
    </div>
  }

  @if ((onkoLlmTestausKayttajaObservable | async) && valitutTestisettiin().size) {
    <div class="testisetti-fab lemon-mat-elevation-z4">
      <span class="testisetti-fab-teksti">{{ valitutTestisettiin().size }} tositetta valittu</span>
      <div class="testisetti-fab-napit">
        <app-button (click)="tyhjennaTestisettiValinta()" actionId="Tyhjennä LLM-testisettivalinta">Tyhjennä</app-button>
        <app-primary-button (click)="lisaaValitutTestisettiin()" matIcon="playlist_add" actionId="Lisää valitut tositteet LLM-testisettiin">Lisää testisettiin</app-primary-button>
      </div>
    </div>
  }
</div>

<app-tosite-haku [avoinna]="hakuAvoinna" (suljettu)="suljeHaku()"></app-tosite-haku>
